import { useService } from 'react-reservice';

import { pickProperties } from '@aqx-core/common/services/utils';

import { IEquityChartServiceContext, equityChartService } from './service';

export const useChartWithKeys = <K extends keyof IEquityChartServiceContext>(keys: K[]) => {
  return useService(equityChartService, (context) => {
    return pickProperties(context || {}, keys);
  });
};

export const useOrderTrackers = () => {
  return useService(equityChartService, (context) => context.orderTrackers);
};

export const useAskPriceVisible = () => {
  return useService(equityChartService, (context) => context.askPriceVisible);
};

export const useTechnicalIndicators = () => {
  return useService(equityChartService, (context) => context.technicalIndicators);
};

export const useSelectedPeriod = () => {
  return useService(equityChartService, (context) => context.selectedPeriod);
};

export const useSelectedSeries = () => {
  return useService(equityChartService, (context) => context.selectedSeries);
};

export const useChartProvider = () => {
  return useService(equityChartService, (context) => context.selectedProvider);
};
